'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactUtils = require('react-utils');

var _utils = require('./utils');

var _Functions = require('../core/Functions');

var IMEAware = (0, _utils.eventHandlerDecoratorFactory)({
  displayNameFunc: function displayNameFunc(Component) {
    return 'IMEAware(' + (0, _reactUtils.getComponentName)(Component) + ')';
  },

  eventHandlers: {
    onCompositionStart: function onCompositionStart(evt) {
      this.setState({ composing: true });
      (0, _Functions.callIfPossible)(this.props.onCompositionStart, evt);
    },
    onCompositionEnd: function onCompositionEnd(evt) {
      this.setState({ composing: false });
      (0, _Functions.callIfPossible)(this.props.onCompositionEnd, evt);
    }
  },

  getPropsForRender: function getPropsForRender(props, state) {
    return _extends({}, props, {
      _composing: state.composing || false
    });
  }
});

exports.default = IMEAware;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/decorators/IMEAware.js
// module id = 313
// module chunks = 0